import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import EditIcon from '@material-ui/icons/Edit'
import Form from "@rjsf/material-ui"
import PropTypes from 'prop-types'
import React from 'react'
import { formSchema, uiSchema } from './schema'


const EditAssetDialog = ({ OnEditAsset, asset }) => {
	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
	}

	const onSubmit = (value, callback) => {
		value.formData._id = asset._id;
		setOpen(false)
		OnEditAsset(value.formData);
	};


	return (
		<div>
			<Tooltip title='Edit an Asset'>
				<IconButton aria-label="edit" onClick={handleClickOpen}>
					<EditIcon />
				</IconButton>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>

				<DialogTitle id="form-dialog-title">Edit Asset</DialogTitle>
				<DialogContent>
					<Form
						schema={formSchema}
						onSubmit={onSubmit}
						uiSchema={uiSchema}
						formData={asset}
						// liveValidate
						showErrorList={false}
					>
						<div style={{ textAlign: 'center', paddingTop: '15px' }}>
							<Button type={'submit'} color="primary">
								Save
							</Button>
						</div>
					</Form>
				</DialogContent>
				<DialogActions>
				</DialogActions>
			</Dialog>
		</div>
	)
}

EditAssetDialog.propTypes = {
	OnEditAsset: PropTypes.func.isRequired,
}

export default EditAssetDialog
